import { arch, platform, release, type } from "os";
import { Signer } from "@flixxo/authorizator";
import packageInfo from "../../package.json";
import Axios from "axios";
import i18n from "i18n";
import useSession from "./useSession";
import { RECAPTCHA_TYPES } from "config/constants";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { environment } from "config/environment";
import { GAHandler } from "utils/GA";

const API_URL = environment.apiUrl;
const OSINFO = `${platform()}; ${type()} ${arch()} ${release()}`;
const ENV = environment.name;
const AGENT =
  `${packageInfo.build.appId}/${packageInfo.version} ` +
  `(${OSINFO}) ${packageInfo.name} (${ENV}) ` +
  `node/${process.versions.node} ` +
  `chrome/${process.versions.chrome} ` +
  `v8/${process.versions.v8} `;

const useApi = () => {

  const { secret, logout } = useSession();
  const { executeRecaptcha } = useGoogleReCaptcha();

  let signer;
  if (secret) signer = new Signer(secret);

  const baseURL = `${API_URL}/api`
  
  const apiFetch = async ({
    url,
    customHeaders = {},
    method = 'get',
    data = {},
    captcha = {}
  }) => {
   
    const ronly = url.replace(/\?[\s\S]*$/g, "");

    const lang = localStorage.getItem('i18nextLng')

    let authToken;
    if (secret) authToken = await signer.generateToken(ronly);

    const auth = secret ? {Authorization: `Basic ${btoa(authToken.toString())}`} : {}

    let captchaTokenV3 = ''
    if (captcha.type === RECAPTCHA_TYPES.v3) {
      captchaTokenV3 = await executeRecaptcha(captcha.action);
    }

    return Axios({
      baseURL,
      url,
      method,
      data,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Flixxo-Client": AGENT,
        "x-flixxo-lang": lang,
        'x-flixxo-captcha-type': captcha.type,
        'x-flixxo-captcha-token': captchaTokenV3,
        ...auth,
        ...customHeaders
      }
    })
    .catch(({ response }) => {

      const code = response.status
      const error = response.data.error

      GAHandler('res_error', error)

      if (code === 401) logout?.()

      const newError = {
        code,
        message: error?.message,
        name: error?.name,
        details: error?.details
      }

      throw newError
    })
  }

  return { apiFetch }
}

export default useApi;
